import React from "react";
interface ProjectProps {
  id: string;
  languages: string[];
  link: string;
  image: any;
  title: string;
  description: string;
}

const Project: React.FunctionComponent<ProjectProps> = ({
  id,
  languages,
  link,
  image,
  title,
  description,
}) => (
  <div className="project" id={id}>
    <img src={image} />
    <div className="description">
      <div className="languages">
        {languages.map((language) => (
          <span className={language}>{language}</span>
        ))}
      </div>
      <h1 className="title">{title}</h1>
      <p>{description}</p>
      <div className="button">
        <a href={link} target="_blank">
          <span>Github</span>
        </a>
      </div>
    </div>
  </div>
);

export default Project;
